import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { matchingReducer } from './matching.reducer';
import { MatchingEffects } from './matching.effects';

@NgModule({
  imports: [
    StoreModule.forFeature('matching', matchingReducer),
    EffectsModule.forFeature([MatchingEffects])
  ]
})
export class MatchingStateModule {}
